// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__NA2Ri","startLink":"Breadcrumbs_startLink__ObvuV","separator":"Breadcrumbs_separator__Tycos"};